module.exports = __webpack_public_path__ + "assets/zenefits-622c23456be66402489c905cf586fa58.svg";